import { MutationTree, GetterTree, ActionTree } from 'vuex';
import NotificationService from '../services/Notification.service';

export interface NotificationState {
  unreadCount: number;
  showProfileDot: boolean;
}

export const state: () => NotificationState = () => ({
  unreadCount: 0,
  showProfileDot: false,
});

export const getters: GetterTree<NotificationState, Record<string, unknown>> = {
  getUnreadCount: (state) => {
    return state.unreadCount;
  },
};

export const mutations: MutationTree<NotificationState> = {
  setUnreadCount(state, unreadCount) {
    state.unreadCount = unreadCount;
  },
  setShowProfileDot(state, showProfileDot) {
    state.showProfileDot = showProfileDot;
  },
};

export const actions: ActionTree<NotificationState, Record<string, unknown>> = {
  async loadUnreadCount({ commit }, data) {
    const { customerToken } = data;

    try {
      const notificationService = new NotificationService();
      notificationService.setCustomerToken(customerToken);

      const count = await notificationService.loadUnreadCount();

      commit('setUnreadCount', count);
      commit('setShowProfileDot', count > 0);
    } catch (e) {
      this.$sentry.captureException(e, {
        tags: { 'process.type': process.server ? 'server' : 'client' },
      });
    }
  },
};
